import { PlatePluginComponent, TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { DreamBlock } from '@typedream/core';
import { createTElementPluginFactory, DreamElementKey } from '../../plate';
import { ELEMENT_FORM_INPUT } from '../../pluginKeys';
import { FormInputElementEditor } from './components/FormInput';
import { FormInputPluginOptions } from './types';
import { withFormInput } from './withFormInput';
import { withDropTarget } from '../../plugins/dnd';

export const createFormInputPlugin = createTElementPluginFactory({
  key: ELEMENT_FORM_INPUT,
  component: withDropTarget(FormInputElementEditor as ComponentType<TRenderElementProps>),
  withOverrides: withFormInput,
  isVoid: true,
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: {
      dimensionIndicator: true,
    },
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/images/form.png',
      title: 'Form Input',
      subtitle: 'Collect data from your users using form',
      keywords: ['form', 'submission'],
    },
    format: {
      formatType: 'block',
      turnInto: [],
      insertNode: {
        // id is going to be set by editor normalizer
        id: '',
        type: ELEMENT_FORM_INPUT,
        inputType: 'text',
        label: 'Input Label',
        placeholder: 'Enter something here',
        required: false,
        disabled: false,
        is_label_hidden: false,
        // name is going to be set by plugin normalizer
        name: '',
        children: [
          {
            text: '',
          },
        ],
      },
      focusableWhenEmpty: false,
      validProperties: (el: DreamBlock) => {
        if (el.type !== ELEMENT_FORM_INPUT) {
          return [];
        }

        const properties: DreamElementKey[] = ['inputType', 'label', 'required', 'disabled', 'is_label_hidden', 'connect_data'];
        // append 'placeholder' if input type is not multiselection
        if (el.inputType !== 'multiselection') {
          properties.push('placeholder');
        }

        return properties;
      },
    },
    // NEED TO OVERRIDE THIS!
    initialFormData: {} as any,
  },
} as {
  key: DreamBlock['type'],
  component: PlatePluginComponent,
  options: FormInputPluginOptions;
});
